// Generated TypeScript interfaces for order_by

export enum OrderBy {
  WEEK = "week",
  MONTH = "month",
  CUSTOMER = "careplace",
  SUPPLIER = "staff",
  PAYROLL_TAX = "payrolltax",
  REVENUE = "revenue",
  COST = "cost",
  PROFIT = "profit"
}

